export default {
  login: {
    // 登录页面
    inputaccount: '请输入账号',
    inputpwd: '请输入密码',
    login: '登录',
    lospass: '忘记密码',
    openaccont: '开立账户',
    inputphonemail: '请输入手机号码/邮箱',
    recode: '请输入验证码',
    nologin: '未登录，请登录后再试',
    verification: '发送验证码',
    newpass: '请输入新密码',
    pemainotnull: '手机号码/邮箱不能为空',
    asave: '保 存',
    checkphoneemail: '请检查手机号或邮箱是否正确',
    rulepass: '密码格式为8-16位包含大小写字母、数字、特殊字符',
    rulecode: '验证码格式不正确!',
    verinotnull: '验证码不能为空!',
    serviceerror: '服务异常,请联系客服!',
    tafter: 's后再试',
    serviceerr: '服务出错,请联系客服!',
    acconly: '登录账号只能输入手机号，交易账号，邮箱',
    logsucc: '登录成功',
  },
  home: {
    // 首页
    logout: '退出登录',
    customer: '联系客服',
    mcwebsite: '狮子国际官网',
    welcome: '欢迎你!',
    racc: '真实账户',
    dacc: '模拟账户',
    ihome: '首页',
    lastlog: '上次登录',
    balance: '账户余额',
    networth: '净值',
    margin: '可用保证金',
    injection: '注资',
    withdraw: '取款',
    customerstatus: '机构客户情况',
    todaynews: '今日动态',
    commissions: '新增佣金',
    newcust: '新增客户',
    newdeposits: '新增入金',
    subordinate: '说明：以上为您名下全部客户及下属机构客户变化情况总览。',
    cdetails: '返佣明细',
    more: '更多',
    cinews: '注资动态',
    ordernum: '订单号',
    amount: '金额',
    deposittime: '充值时间',
    depositmethod: '充值方式',
    status: '状态',
    dynamics: '提款动态',
    fee: '手续费',
    applicationt: '申请时间',
    operation: '操作',
    cantapp: '取消申请',
    lateann: '最新公告',
    nodate: '暂无数据',
    mccs: '宝汇客服',
    equivalent: '模拟账户是一个等同于真实情境的演练场，但所交易的皆为虚拟资金，不可以提现。如果您已经掌握基本交易规则，激活真实账户，开启真正的投资里程吧！',
    perfected: '一方实战场地，注资将不再受限制，赚取真金白银后也可以立即提现。如果您已经掌握基本规则，完善身份资料，激活真实账户试试身手吧！',
    buttonbelow: '点击下面的按钮，即可激活模拟交易账户。',
    identity: '点击下面的按钮，完善身份资料，即可激活真实交易账户。',
    araccount: '激活真实账户',
    previous: '上一篇',
    next: '下一篇',
    iprotect: '为了更好地保障您的资金安全，首次入金前请先完成实名认证',
    goautht: '前往实名认证',
  },
  und: {
    // 名下用户列表
    undername: '名下用户列表',
    tracc: '交易账号',
    acctype: '账户类型',
    regdate: '注册日期',
    tinfom: '交易信息',
    lowlevel: '修改下级返佣',
    lowlevels: '机构客户升级',
    export: '导出',
    cgrade: '客户升级',
    rebate: '您在这里设置下级机构客户每种商品的返佣金额（返佣/手），不能超过您自己的返佣金额',
    cname: '客户姓名',
    frebate: '外汇类返佣：',
    ulot: '美元/手',
    srebtae: '股票类返佣：',
    indexc: '指数类：',
    chinar300: '中华300返佣：',
    chinar50: '中华50返佣：',
    rebates: '其它指数返佣：',
    comclass: '商品类：',
    lgrebate: '伦敦金返佣：',
    lsrebate: '伦敦银返佣：',
    usoilrebate: '美国原油返佣：',
    ukoilrebate: '英国原油返佣：',
    cryrebates: '数字货币类返佣：',
    btccomm: '比特币返佣：',
    otherrebates: '数字货币返佣：',
    cancel: '取 消',
    confirm: '确 定',
    Reset: '重置',
  },
  details: {
    // 名下用户交易信息
    inscustom: '机构客户',
    ordcustom: '普通客户',
    return: '返回',
    funinfo: '资金信息',
    position: '持仓',
    balance: '余额',
    networth: '净值',
    tradtype: '交易品种',
    transetype: '交易类型',
    transets: '交易类型：',
    lotsize: '手数',
    opetime: '建仓时间',
    opeprice: '建仓价',
    closet: '平仓时间',
    closets: '平仓时间：',
    stoptake: '止损/止盈价',
    invfee: '库存费',
    closeposition: '平仓',
    to: '至',
    startd: '开始日期',
    endd: '结束日期',
    choose: '请选择',
    enterc: '请输入内容',
    query: '查询',
    proloss: '总盈亏',
    tataltrance: '交易量合计',
    lindgold: '伦敦金：',
    lindgolds: '伦敦金',
    usoil: '美国原油：',
    usoils: '美国原油',
    forexchange: '外汇：',
    china300: '中华300：',
    china50: '中华50：',
    china300s: '中华300',
    china50s: '中华50',
    lonsilv: '伦敦银：',
    lonsilvs: '伦敦银',
    britishoil: '英国原油：',
    britishoils: '英国原油',
    stock: '股票：',
    oindex: '其他指数：',
    btc: '比特币：',
    otherbtc: '数字货币：',
    closepr: '平仓价',
    proloass: '盈亏',
    settlecomm: '结算佣金',
    settlecomms: '结算返点（$）',
    ordnum: '订单编号',
    ordite: '订单商品',
    salet: '买卖类型',
    traclient: '交易客户',
    insclients: '所属机构客户',
    ownrebate: '自己返点标准',
    lowerlev: '下级返点标准/止盈价',
    cumulateive: '累计入金',
    Cumulateivein: '累计出金',
    netdeposit: '净入金',
    opetdate: '操作日期',
    opettype: '操作类型',
    amount: '金额（$）',
    amountr: '金额（￥）',
    lweek: '最近一周',
    lmonth: '最近一个月',
    lthrmon: '最近三个月',
    totaltra: '总交易量',
  },
  commiss: {
    comman: '佣金管理',
    ewallet: '电子钱包',
    comtype: '佣金结算类型',
    walletbal: '电子钱包（余额）',
    transfermt4: '转入MT5：',
    transferamo: '转入金额：',
    amountomt4acc: '转入MT5帐号的金额',
    submit: '提 交',
    tips: '温馨提示',
    tips1: '钱包余额可以入金到MT5账户，不收取任何费用。',
    tips2: '钱包余额入金到MT5的操作，每日只能操作一次',
    lgus5: '转入银行卡时，最低金额必须≥$5',
    process: '您当前已经有一笔出金申请正在处理中...',
    vuedetail: '查看详情',
    totalcomm: '总结算返点',
    ownlow: '下级返点标准',
  },
  report: {
    underreps: '名下客户持仓报表',
    underrep: '报表',
    selecttype: '请选择交易品种',
    ordnumber: '请输入订单号',
    entaccname: '请输入交易账号/客户姓名',
    selecttt: '请选择交易类型',
    totalposi: '持仓总笔数',
    totalposih: '持仓总手数',
    clientsta: '名下客户平仓报表',
    totalnumposc: '平仓总笔数',
    totalnumposl: '平仓总手数',
    totalproloss: '总平仓盈亏',
    interest: '仓息',
    clifunstat: '名下客户资金报表',
    entoptuser: '请输入操作用户',
    totalwithdra: '出金总笔数',
    totalnumdep: '入金总笔数',
    totalwitham: '出金总金额',
    totaldepam: '入金总金额',
    opttime: '操作时间',
    opeuser: '操作用户',
    losscus: '名下客户盈亏报表',
    totalnumtra: '交易总人数',
    tradet: '交易明细',
    travolstavar: '各品种交易量统计',
  },
  link: {
    pulllink: '推广链接',
    tpsi: '温馨提示:通常适用于在博客,论坛,聊天工具,网站,电邮这些地方使用。',
    copy: '复制',
    qqlink: '点击“复制”后，将推广链接粘贴 到QQ群或者发送给你的QQ好友',
    weblink: '将内容分享到您的微博、人人网、 空间，轻松体验赚钱的乐趣',
    morelink: '点击“复制”后，将推广链接粘贴 到各大贴吧或者论坛',
    copysucc: '复制成功！',
  },
  basic: {
    realname: '实名认证',
    idpic: '证件图片',
    upload: '点击上传',
    carderr: '卡证文字识别失败，您可以重新上传图片再次尝试，或手动填写身份资料，走人工审核通道。',
    manent: '手动录入资料',
    cheinfo: '请核对如下信息，如与您提交的证件信息不符，可尝试重新提交图片，或手动修改，走人工审核通道。',
    repairre: '修改识别结果',
    name: '姓名',
    certty: '证件类型',
    antwallet: '蚂蚁钱包认证',
    identifie: '待识别',
    entname: '请输入姓名',
    idnmu: '证件号码',
    idcard: '身份证',
    passport: '护照',
    other: '其他',
    eveare: '请选择活动区域',
    fairea: '失败原因：',
    safety: '为了保障您的财产安全，请填写真实身份资料信息；',
    completing: '完成实名认证及银行卡绑定后，方可申请提现；',
    max5m: '图片格式：支持jpg/png/jpeg格式，图片大小不超过5M。',
    Resubmit: '重新提交',
    automatic: '您的身份资料未能通过自动校验，您可以选择：',
    resubinfo: '核对并修改资料，重新提交；',
    correct: '如果确认资料无误，请走人工审核通道，客服人员会尽快协助您解决此问题',
    cheinfomation: '核对资料',
    subman: '提交人工审核',
    onlineservice: '认证失败，如有疑问请联系在线客服',
    onlinecusser: '在线客服',
    entidnum: '请输入证件号码',
    entcorrect: '请输入正确的证件号码',
    selectdoc: '请选择证件类型',
    cardfront: '身份证正面',
    cardback: '身份证反面',
    upfrontcard: '请上传身份证正面',
    upbackcard: '请上传身份证反面',
    notverified: '未认证',
    verifica: '待审核，请等待...',
    verpass: '审核通过',
    verfailed: '审核未通过',
    otherdocu: '其它证件',
    sizemax5m: '上传头像图片大小不能超过 5MB!',
    frontdoc: '证件正面',
    backdoc: '证件反面',
    subing: '正在提交...',
    submit: '提交',
    allup: '请检查证件照片是否全部上传',
    verwait: '验证中,请稍等...',
    logexp: '登录过期，请重新登录',
    statement_text_title: '重要声明：',
    statement_text:
      '填写本问卷表示客户本人已接受风险承受能力的问卷调查，完全知悉所投资产品的风险类别，且客户本人所作出的所有投资决定，均是基于客户本人的判断，并无条件承诺自行承担一切投资风险和相关责任。',
    toast: '问卷信息未填写完',
    nav_title: '交易评估表',
    tip_text: '提交审核文件前，为了确保您已经了解CFD产品交易的相关风险以及判断自身投资的情况，请根据您目前的状况填写以下表格：',
    van_button: '确认提交',
  },
  bank: {
    bankcard: '银行卡：',
    name: '姓名：',
    idnumber: '证件号码：',
    banknumb: '银行卡号：',
    entbankcard: '请输入银行卡号',
    bankname: '银行名称：',
    bankloca: '银行所在地区: ',
    bankbran: '分/支行名称: ',
    bankphon: '银行预留手机：',
    entbranch: '请用英文填写分/支行名称',
    entbranchs: '请填写分/支行名称',
    entbankmob: '请输入银行预留手机',
    bic: '请输入 Sort code/SWIF/BIC',
    entcorr: '请输入正确的手机',
    bankima: '银行卡图片',
    proacco: '银行资料将会作为您提现的收款账户，为保障您的资金安全，请确保信息准确无误；',
    banksub: '银行资料一经提交成功，便无法自行修改，若要变更，请',
    contactcus: '联系客服',
    combind: '请先完成实名认证，再绑定银行卡！',
    entdigit: '请输入6-19位银行卡号',
    selregion: '请选择银行所在区域',
    entbankname: '请输入银行名称',
    entbanknames: '请用中文填写银行名称',
    name2to50: '分支行名称在 2 到 50 个字',
    upphoto: '请上传银行卡正面照片',
    notverif: '未审核',
    verified: '已认证',
    failveri: '审核失败',
    upfrontimag: '请先上传银行卡正面图片',
    Confirm: '确定',
    choose: '请选择',
    state_text: ['待审核', '审核通过', '审核未通过'],
    noDataText: '您还没有绑定银行卡',
    unbind_message: '确定要删除该银行卡吗？',
    updateSuccess: '设置成功',
    add_bank: '添加银行卡',
    default: '默认',
    default_button: '设为取款到账卡',
    unbind: '解除绑定',
  },
  paw: {
    chapass: '修改密码',
    entnewpass: '输入新密码：',
    entpassagain: '再次输入新密码：',
    againentpass: '请再次输入新密码',
    vercode: '验证码：',
    bindphonef: '请先绑定手机或邮箱',
    notmatch: '两次输入密码不一致!',
    reasec: '秒后重新获取',
    getverifi: '获取验证码',
  },
  dep: {
    Injection: '注资',
    capamoun: '注资金额',
    Dollar: '美元',
    d600: '600美元',
    d500: '500美元',
    d300: '300美元',
    d200: '200美元',
    traaccount: '交易账户:',
    equal: '约等于',
    rmb: '人民币',
    avaliable: '今日还可注资',
    time: '次',
    madeonce: '模拟账户每天可注资一次,每次10000美元；',
    amountrmb: '人民币金额仅供参考；',
    capitalinj: '此处注资金额为虚拟资金,只能用于模拟交易,不能提现。',
    doubt: '如有疑问,请联系',
    call24line: '或拨打24小时服务热线',
    next: '下一步',
    selmet: '选择支付方式',
    WeChat: '微信',
    Alipay: '支付宝',
    paid: '实付',
    return: '返&nbsp;&nbsp;&nbsp;&nbsp;回',
    payimm: '立即支付',
    complete30: '请在30分钟内完成支付，逾时订单将被关闭；',
    ifexit: '如果当日存在',
    tran3: '3笔',
    notpaid: '未支付订单，当日将被限制使用网上存款功能；',
    platnotacc: '本平台不接受来自第三方的注资，暂不支持信用卡注资；',
    allaccset: '本平台账户均为美元结算，人民币换算结果仅供参考，以支付平台实时汇率转换结果为准，建议预留汇率浮动空间，以确保您的投资需求；',
    herebycon: '本人确认为账户合法持有人，并确认存入资金与任何非法活动无关；',
    hereconlegal: '本人承诺再次用于注资的银行卡属于本人合法持有，所有注资均由本人操作。',
    entamount: '请输入金额',
    single50: '单笔注资为50到700美金',
    incamount: '金额格式不正确',
  },
  wit: {
    getmet: '正在获取取款方式',
    perpat: '个人信息正在审核，请耐心等待...',
    tipens: '提示：为保障您的资金安全，提现前请先完成以下资料认证！',
    available: '可提取金额：',
    withdraw: '提取金额：',
    conrmb: '换算人民币：',
    huansuan: '换算USDT',
    witmeth: '取款方式：',
    selwithdra: '请选择取款方式',
    uping: '上传中...',
    wechatpay: '获取微信收款码方式：',
    click: '点击',
    me: '我',
    pay: '支付',
    collpay: '收付款',
    qrcode: '二维码收款',
    setamount: '设置金额',
    entrmb: '输入“换算人民币”展示金额',
    cliok: '点击确定',
    reccode: '然后截图收款码',
    withqrcode: '您可以通过上传微信收款二维码来提现',
    alicode: '获取支付宝收款码方式：',
    withdrawqr: '您可以通过上传支付宝收款二维码来提现',
    payqracc: '收款二维码需要附带金额，不然可能无法通过申请哦！',
    actualdiff: '实际到账会因合作商户提供渠道有不同，若此支付方式暂无服务亦可能以您的绑定银行卡到账。',
    nohand: '当月首笔出金免手续费；',
    lessthan: '当月第二笔及以上出金，如出金额＜100美元，需扣除5美元手续费；',
    current: '当前有未完成出金订单，则无法提交新的出金申请；',
    succdep: '24h之内有成功入金，无法申请出金；',
    withdrawal: '取款将于财务部门服务时间（工作日09：00-18：00）审核汇出，一般在1个工作日内到账；具体到账时间仍需视乎银行处理速度，约1-3个工作日到账。',
    less50: '出金金额小于50美金，需要扣除3美元手续费；',
    sessdeposit: '总交易金额不足总入金金额的',
    necessary: '则需要扣除本次出金金额的',
    asfee: '做为手续费；',
  },
  fun: {
    details: '资金明细',
    capital: '注资总额：',
    Date: '日期',
    Time: '时间',
    Times: '时间',
    staope: '状态/操作',
    totalwithdra: '提现总额：',
    wdrawamount: '提现金额',
    arrrmb: '实际到账人民币',
    withdrawal: '取款方式',
    address: '到账钱包地址:',
    apptime: '申请提交时间',
    Cancel: '取消',
    Details: '详情',
    orddetail: '订单详情',
    pendingver: '待审核',
    verifying: '审核中',
    wisuccess: '出金成功',
    wifaile: '出金失败',
    ordcannel: '订单取消',
    ordernumb: '订单号：',
    widrawam: '提现金额：',
    hfee: '手续费：',
    appsubtime: '申请提交时间：',
    orderstatus: '订单状态：',
    remark: '备注：',
    remarks: '备注',
    All: '全部',
    ondep: '网上存款',
    banktrn: '银行汇款',
    Mallpayment: '商城支付',
    QuickPayment: '快捷支付',
    Depositonline: '网上充值',
  },
  pos: {
    posi: '持仓',
    travar: '交易品种：',
    buy: '买入',
    sell: '卖出',
    holdtime: '持仓时间：',
    occ: '占用保证金',
    curt: '当前交易记录',
    Notes: '注释',
    closeto: '平仓盈亏',
    notparti: '您还没有参加此活动',
    gotodep: '前往充值，领取奖励',
    actname: '活动名称：',
    acttime: '活动时间：',
    '72hdep': '72小时净入金：',
    cashrew: '美元现金奖励等级：',
    ucrels: '美元现金发放状态：',
    rewlev: '实物奖励等级：',
    rediss: '实物奖励发放状态：',
    nameact: '活动名称：',
    timeact: '活动时间：',
    recaward: '联系客服领奖',
    rewdistr: '实物奖励发放时间：',
    rewactdi: '实物奖励实际发放物品：',
    pending: '待定级',
    pendingr: '待发放',
    issued: '已发放',
    expired: '已过期',
    notstandard: '未达标',
    grouped: '待分组',
    notissued: '未发放',
    expired1: '已失效',
  },
  down: {
    softdown: '软件下载',
    downmt4: '下载MT5交易软件/宝汇投资APP，即刻开始交易',
    mt4trad: 'MT5交易平台',
    mt4prof:
      'MT5是一款可同时交易外汇、贵金属的专业交易软件。其综合了行情图表、技术分析、交易操作三大功能于一身，可进行下单、平仓限价单、止损、止赢、查看报表及分析数据等不同操作，是目前最为广泛使用的外汇行情软件之一。目前在全球超过300家经纪商及银行正在使用MT4平台作为交易平台，是全球最受欢迎的在线交易平台。',
    insquot: '提供即时报价',
    simpflex: '简易操作、下单灵活',

    riskfun: '具备止损获利等风险控制功能',
    lockfun: '具备锁仓功能',
    charts: '价格图表清晰直观',
    intuitive: '画图工具及技术分析指标方便易用',
    install: '安装便捷，占用系统资源小',
    versiond: 'MT5 PC版下载',
    scanqr: '扫描二维码下载移动端',
    mcappcon:
      '宝汇投资APP是我们公司为客户精心打造的一款手机行情软件，在这里你能得到全方位的国内外贵金属行情、国内外期货行情、全球指数、财经资讯等服务。炫酷的页面设计，极快的数据传输速度、流畅的体验加上其强大的数据信息，能够为您提供更准确更实时的财经数据、行情报价，以及独家解盘评论，让您不论身在何处都可以运筹帷幄，享受智盈人生。',

    marketany: '随时随地查看行情数据，数据传输快速稳定',
    comprehensive: '全面客观的技术分析总结和建议',
    economy: '宏观经济面了解经济状况',
    quickopen: '快速开户，实时登录注资取款',
    onemachine: '一机在手，交易无忧',
    macapp: '宝汇投资APP',
  },
  sug: {
    acom: '提交投诉建议',
    dissatisfied: '如果您对我们的服务有不满之处，请在此提交留言，我们会尽快给予答复或处理，谢谢！',
    title: '标题：',
    enttile: '请输入标题',
    comtype: '投诉类型：',
    seltype: '请选择投诉类型',

    sersug: '服务改善建议',
    complain: '投诉客户服务',
    problem: '交易账号问题',
    deposits: '账户资金存取',
    website: '网站推广/客服',
    orderap: '交易订单申诉',

    visit: '回访类型：',
    onlinemeg: '在线留言',
    spe: '专人回电',
    appointment: '预约时间：',
    sappointment: '请选择预约时间',
    content: '内容：',
    contentc: '内容',
    entres: '请输入预留信息',
    comret: '投诉建议回访',
    moddate: '修改日期：',
    selvisit: '请选择回访类型',
    subtime: '提交时间',
    type: '类型',
    Reply: '回复',
    notpro: '未处理',
    replyd: '已回复',
    over: '已结束',
    sappointments: '请选择预约时间！',
    blank: '标题不能为空！',
    thanks: '感谢您的关注和反馈,我们的工作人员稍后会和您联络,请保持手机畅通,祝您生活愉快!',
    subsucc: '提交成功',
  },
  msg: {
    announ: '公告',
    staletter: '站内信',
    contactus:
      '宝汇投资是专业的外汇及差价合约交易平台，领有塞浦路斯证券交易委员会牌照（CySEC） , 牌照号:299/16。通过行业监管，加强保障顾客资金安全的同时，致力为全球投资者提供多元化的综合性投资服务,包括外汇、指数、原油、贵金属、美股等杠杆式差价合约交易。',
    contactus2:
      '宝汇投资拥有先进的MT5电子交易平台系统及自行研发交易APP软件，投资者可参与到规模巨大的国际投资市场，快速执行交易，斩获利润。从报价到成交，均严格规范、透明度高。同时投资者可在同一平台全面、灵活地管理不同投资产品，满足各种不同投资者的需求。',
    contactus3: '此外，公司还拥有7*24小时的服务团队，随时为投资者解决投资过程中遇到的疑惑，给您最佳的投资体验！',
    coninfo: '联系方式：',
    cusemail: '客服邮箱：cs@prowayxau.com',
    custeleph: '客服电话：400-842-3990',
    statistics: '机构客户数：',
    comcus: '普通客户数：',
    totaldep: '总入金：',
    totalde: '总入金',
    totalwit: '总出金：',
    totalwi: '总出金',
    totalreb: '总返佣：',
    totalre: '总返佣',
    report: '*此报表展示该客户名下整条代理链的加总数据(包含客户自己)，非客户个人数据。',
    numcus: '客户数',
    loginout: '是否确定退出用户中心?',
    tryagain: '请重试',
    notsub: '非工作时间，暂时无法提交出金',
  },
  menu: {
    ib: '机构客户专区',
    sib: '名下用户',
    stics: '名下用户数据统计',
    sions: '佣金管理',
    repview: '报表预览',
    rlink: '推广链接',

    ainfo: '账户资料',
    poi: '实名认证',
    bard: '银行卡',
    cpass: '修改密码',

    mmange: '资金管理',
    injects: '注资',
    widraw: '取款',
    fdet: '资金明细',
    qbdz: '钱包地址管理',
    tradi: '交易信息',
    posit: '持仓',
    closep: '平仓',
    actcen: '活动中心',
    firste: '首充活动',
    servce: '服务中心',
    down: '软件下载',
    sugge: '投诉建议',
    mymess: '我的消息',
    conus: '联系我们',

    invfri: '邀请好友',
    invfris: '活动主页',
    bonus: '奖励明细',
    setrec: '结算记录',

    firseven: '首充活动',
    bemail: '绑定邮箱',
    changephone: '更换绑定手机',
    uc: '用户中心',
    activityList: '活动大厅',
    myActivity: '我的活动',
    activityDetail: '活动详情',
    marathon: '马拉松活动',
  },
  meta: {
    base: '用户中心',
    phonotblank: '手机号码不能为空',
    corrpho: '请输入正确的手机号码',
    entcode: '请输入正确的验证码',
    entemail: '请输入邮箱地址',
    gpver: '前往验证',
    fillmail: '请填写正确的邮箱',
    emailnotnull: '邮箱不能为空',
    querstion: '，如有疑问，请联系在线客服',
    bounde: '已绑定邮箱',
    chaemail: '修改邮箱',
    entnewpho: '请输入新的手机号码',
    chapho: '修改绑定手机',
    setp1: 'Step1 验证身份',
    step2: 'Step2 绑定新手机',
    currentpho: '当前绑定手机',
    cuurn: '已绑定手机无法接收验证码',
    authcurr: '使用当前绑定手机验证身份',
    phobound: '手机号已绑定',
    failedem: '邮箱验证失败，如有疑问，请联系在线客服',
    phobeenbound: '手机号码已注册',
    Reminder: '温馨提示：验证码已发送至您的邮箱',
    mailbox: '请前往邮箱查看',
    boundsucc: '完成绑定',
  },
  active: {
    score: '我的成绩',
    title_span_1: '盈亏金额',
    title_span_2: '预计可提现',
    resetButton: '申请重置活动',
    h4_title: '活动详情',
    status: '活动状态:',
    starttime: '开始时间:',
    endtime: '结束时间:',
    resetnum: '剩余重置次数:',
    rstprofit: '盈亏:',
    balance: '账户余额:',
    award: '奖励余额:',
    Invalid: '错误请求，请联系管理员',
    failed: '请求失败，请联系管理员',
    size5: '上传图片大小不能超过 5MB!',
    upfail: '上传失败',
    failgetimg: '获取图片地址失败',
    Scantopay: '充值码支付',
    infver: '资料认证',
    china: '中国(大陆)',
    activityStatus: ['进行中', '已结束', '报名中'],
    detailsState: ['进行中', '已完成'],
  },
  banck: {
    addcard: '添加银行卡',
    cardholder: '持卡人姓名：',
    bankpro: '银行所在地区：',
    Branch: '分/支行名称：',
    submitting: '提交后客服将对您的银行卡资料进行认证审核，只有审核通过的银行卡才能用于提现；',
    approved: '银行资料一经提交成功，便无法自信修改，若要变更，请联系客服；',
    funding: '银行卡资料关系到您的资金安全，请确保信息准确无误。',
    digit: '请输入16-19位银行卡号',
    phonenum: '请输入手机号码',
    digit11: '请输入11位手机号码',
    otherbanks: '其他银行',
    bankinfoma: '银行卡资料',
    shared: '共有',
    verify: '张银行卡/最多可绑定',
    piece: '张',
    Reserved: '预留手机号',
    Safestate: '安全状态',
    Remove: '解绑',
    bankdetail: '银行卡详情',
    BankName: '开户行：',
    cardholde: '持卡人：',
    Reserve: '预留手机：',
    Verification: '绑定时间：',
    cerstatus: '认证状态：',
    keepone: '至少保留一张认证卡',
    curcontinue: '此操作将从列表删除当前银行卡, 是否继续?',
    Note: '提示',
    remsuc: '解绑成功!',
    Cancelled: '已取消解绑',
    ver3card: '最多绑定三张银行卡',

    bindexist: '绑定已有的真实账户',
    bindexistd: '绑定已有的模拟账户',
    acc: '帐号',
    entyacc: '请输入帐号',
    password: '密码',
    bindnow: '立即绑定',
    actdemoacc: '激活模拟账户',
    virtra: '是一个虚拟的网上交易账号，账户中的资金为虚拟，商品、报价、图表、买卖等均与真实交易系统即时同步，是新手入门贵金属交易的最佳演练场。',
    Realname: '真实姓名',
    entyourrn: '请输入真实姓名',
    China: '中国大陆',
    chihk: '中国香港',
    chimac: '中国澳门',
    chitw: '中国台湾',
    othcoun: '其他国家及地区',
    setpassword: '设置密码',
    promnum: '推广编号',
    entpronum: '请输入推广编号（非必填）',
    mobilephone: '手机',
    noacctoopen: '无真实账户，马上去激活',
    nodemoacc: '无模拟账户，马上去激活',
    notblank: '姓名不能为空',
    incfor: '姓名格式不正确!',
    idnumnotblank: '证件号码不能为空',
    entidcorr: '请正确输入证件号码!',
    idbeenreg: '证件号码已被注册!',
    pasnotempty: '密码不能为空',
    invformat: '帐号格式错误',
    pass6: '密码最少6位',
    youaccis: '您的真实帐号为',
    activation: '激活成功',
    demoacc: '您的模拟帐号为',
    inviterew: '邀请奖励',
    Invitee: '被邀请人：',
    nameacc: '请输入姓名/交易账号',
    invnumb: '邀请人数/人',
    activenump: '激活人数/人',
    trewards: '交易奖励',
    continutrading: '连续交易奖励',
    rewards: '产生奖励',
    inviterews: '被邀请奖励',
    bindinvcode: '绑定邀请码：',
    enterinvite: '请输入邀请码',
    bind: '绑定',
    Invitepeople: '邀请人',
    Rewconsecutive: '已达成连续交易奖励',
    Eightweek: '八周交易手数统计',
    Eightweekcou: '八周倒计时',
    BasicInfor: '基本信息',
    accoptime: '开户时间',
    earntime: '收入时间',
    gentrarewards: '已产生交易奖励',
    day180lots: '180天内交易手数',
    day180down: '180天倒计时',
    Continuous: '连续',
    weeklots: '周平仓手数均',
    cangethand: '手时，双方均可获得',
    invcodenotempty: '邀请码不能为空',
    earnedon9: '每天上午9:00 结算前一日奖励',
    accumrews: '累计获得奖励',
    rewardsstet: '待结算奖励',
    rewandsetl: '奖励与结算',
    numofinvite: '邀请人数',
    yesterdayrew: '昨日结算奖励',
    promocode: '我的推广码',
    clicksave: '点击保存二维码',
    promotion: '您的推广码为',
    copypromo: '点击复制推广码',
    promolink: '您的推广链接为',
    copylink: '点击复制推广链接',
    procodebind: '推广码：复制后发送给被邀请人，被邀请人在用户中心绑定即可；',
    prolinkcopy: '推广链接：复制后发送给被邀请人，被邀请人通过链接开户成功自动绑定；',
    qrcodesave: '二维码：点击二维码保存图片，被邀请人扫码开户成功后自动绑定。',
    accnotactive: '账户尚未激活，无法使用推广功能',
    activatedt: '激活账户，启用我的推广码',
  },
  set: {
    settleteime: '结算时间',
    setamo: '结算金额',
    stpset: 'STP设置',
    ecnset: 'ECN设置',
    indexclass: '指数类',

    frebate2: '外汇类返点：',
    srebtae2: '股票类返点：',
    chinar300s: '中华300返点：',
    chinar50s: '中华50返点：',
    rebates2: '其它指数返点：',
    comclass2: '商品类：',
    lgrebate2: '伦敦金返点：',
    lsrebate2: '伦敦银返点：',
    usoilrebate2: '美国原油返点：',
    ukoilrebate2: '英国原油返点：',
    cryrebates2: '数字货币类返点：',
    btccomm2: '比特币返点：',
    otherrebates2: '数字货币返点：',
    Group: '用户组别',
    groper: '组别权限',

    ukoilrab: '请输入英国原油返点',
    correbate: '请输入正确的英国原油返点金额',
    entcha300: '请输入中华300返点',
    entcorcha300: '请输入正确的中华300返点金额',
    entcha50: '请输入中华50返点',
    entcorcha50: '请输入正确的中华50返点金额',
    entusoilr: '请输入美国原油返点',
    encortusoilr: '请输入正确的美国原油返点金额',
    entfxr: '请输入外汇类返点',
    entcorfx: '请输入正确的外汇类返点金额',
    entxauusd: '请输入伦敦金返点',
    entcorxauusd: '请输入正确的伦敦金返点金额',
    entothindex: '请输入其它指数返点',
    entcorindex: '请输入正确的其它指数返点金额',
    entxagusdr: '请输入伦敦银返点',
    entcorxagusd: '请输入正确的伦敦银返点金额',
    stockrebate: '请输入股票类返点',
    entcorstock: '请输入正确的股票类返点金额',
    btc100rebate: '请输入比特币返点',
    btc100cor: '请输入正确的比特币返点金额',
    otherrebate: '请输入数字货币返点',
    corofcrypt: '请输入正确的数字货币返点金额',

    ukoilrebate: '英国原油返点不能大于上级返点',
    chi300: '中华300返点不能大于上级返点',
    chi50: '中华50返点不能大于上级返点',
    usoilrebate: '美国原油返点不能大于上级返点',
    fxrebate: '外汇类返点不能大于上级返点',
    xauusdrebate: '伦敦金返点不能大于上级返点',
    stockrebates: '股票类返点不能大于上级返点',
    btc100rebates: '比特币返点不能大于上级返点',
    cryptos: '数字货币返点不能大于上级返点',
    indexrebates: '其它指数返点不能大于上级返点',
    xagusdreabage: '伦敦银返点不能大于上级返点',

    pre: '上一篇',
    next: '下一篇',
    trebates: '总返点',
    promocode: '推广码',

    sotr: '结算总返佣',
    sor: '结算返点$',
    soc: '结算返佣$',
    ss: '结算状态',
    rr: '返点标准',
    cry: '数字货币类',
    stpview: '点击查看合约细则',
    ecnview: '点击查看合约细则',
    reflink: '邀请链接:',

    stpnocom: 'STP标准账号/无手续费',
    stp10usd: 'STP标准账号/每手10USD手续费',
    stp20usd: 'STP标准账号/每手20USD手续费',
    stp30usd: 'STP标准账号/每手30USD手续费',
    stp40usd: 'STP标准账/每手40USD手续费',
    stp50usd: 'STP标准账号/每手50USD手续费',
    ecnlowspread: 'ECN低点差账号/每手10USD手续费',
  },
  fx: {
    Forex: '外汇类',
    Stock: '股票类',
    index: '指数类',
    btc: '比特币',
    otherbtc: '数字货币',
    Commission: '总返佣',
    deposit: '入金',
    withdraw: '出金',

    withd: '请先选择取款方式',
    failedobtbank: '获取银行卡信息失败，请刷新页面重试',
    failedobt: '获取币地址信息失败，请刷新页面重试',
    fristup: '请先上传收款码',
    insbal: '余额不足',
    balove: '余额超时',
    conf: '请确认',
    mt4suc: 'MT5成功',
    processing: '正在出金',
    min5: '最小金额为 5',
    correctamo: '请填入正确金额',
    maxamount: '可提取金额最大为',
    errgetbal: '获取余额失败',
    faildcny: '获取提现人民币失败',
    wallet: '数字钱包',
    nodemoac: '暂时没有模拟账号',
    suc: '密码修改成功!',
    tout: '登录过期，请重新登录',
    numofdircli: '直属客户数：',
    numofsubid: '下级客户数：',
    recivemail: '验证码已发送，请登录查看',
  },
  wal: {
    def: '默认',
    noadd: '无地址',
    add: '添加',
    rightadd: '请确保您提供的地址正确，因钱包地址错误而导致的财产损失，将由客户个人承担。',
    edit: '编辑',
    del: '删除',
    address: '地址',
    addadr: '添加新地址',
    chain: '链名称',
    wal: '钱包地址',
    waladd: '请输入钱包地址',
    com: '为便于地址管理及使用,可添加简要说明',
    defadd: '设为默认到账钱包地址',
    riaddr: '请输入正确链地址！',
    edadd: '编辑地址',
    addaddr: '新增地址',
    deladdr: '您是否要删除此收币地址?',
    sucdel: '删除成功!',
    chaalr: '已取消删除',
    alre: '已扣除未达标的活动预赠金',
    alre1: '',
  },
  act: {
    fbon: '预赠金',
    bonamount: '预赠金额:',
    lots: '交易手数:',
    stime: '开始时间:',
    etime: '结束时间:',
    prosta: '预赠金状况:',
    nis: '未发放',
    isuse: '已发放',
    comp: '已达标',
    ded: '已扣回',

    gifta: '实物奖励',
    gift: '奖品:',
    giftstatus: '奖励状态:',
    concus: '联系客服，获得奖励!',

    nogroup: '未分组',
    noncon: '未达标',
    complate: '已完成',
    expi: '已失效',

    rece: '已获得',
    notget: '未获得',
    twbon: '台湾首充活动',
    reces: '奖励级别',
    depamo: '首入金额:',
    prost: '活动状态: ',
    fdt: '首充时间:',
    cut72: '首充72小时:',
  },
  tra: {
    rtime: '报名时间:',
    etime: '活动到期时间:',
    lev: '当前奖励级别:',
    gift: '交易有奖活动',
    over: '已结束',
    Dollar: '美元',
    limit: '1000美元以内出金只支持TRC20；',
  },
}



// WEBPACK FOOTER //
// ./src/lang/zh.js